import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var SkipBack = createReactComponent("SkipBack", ["svg", defaultAttributes, [["polygon", {
  points: "19 20 9 12 19 4 19 20",
  key: "1roool"
}], ["line", {
  x1: "5",
  y1: "19",
  x2: "5",
  y2: "5",
  key: "9j6jpp"
}]]]);
export default SkipBack;